(function () {
    'use strict';

    angular
        .module('app')
        .controller('MyConcertsController', MyConcertsController);

    MyConcertsController.$inject = ['$http', '$rootScope', '$stateParams', 'cache', '$state'];

    function MyConcertsController($http, $rootScope, $stateParams, cache, $state) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;

        const vm = this;
        vm.goToTab = goToTab;
        vm.state = $state;
        vm.openImage = openImage;
        vm.concertActions = [];
        vm.promo_pack = [];

        vm.$onInit = function () {
            vm.tab = $stateParams.tab;
            window.document.title = $stateParams.language == 'da' ? "Din profil - Be My Concert" : "Your profile - Be My Concert";
            Promise.all([getUpcomingConcerts(), getPastConcerts(), getUpcomingBookings(), getPastBookings(), getUserAffilliates()]).then(function () {
                vm.upcoming_concerts_and_bookings = sortConcertsAndBookings(vm.upcoming_concerts, vm.upcoming_bookings, "upcoming");
                vm.past_concerts_and_bookings = sortConcertsAndBookings(vm.past_concerts, vm.past_bookings, "past");
                if($stateParams.tab == "upcoming"){
                    goToTab('upcoming')
                }
                if($stateParams.tab == "past"){
                    goToTab('past')
                }
            });
        }

        function openImage(concert) {
            window.open('/app/download.php?f=../uploads/' + (concert.band_image_hash ? 'bands/' + concert.band_slug + '/' + concert.band_image_hash : 'concerts/' + concert.concert_slug + '/1') + '_xl.jpeg').focus();
        }

        function goToTab(tab){
            vm.tab = tab;
            var scrollY = window.scrollY;
            $state.transitionTo('my_concerts', {tab: tab}, {
                location: true, // This makes it update URL
                inherit: true,
                relative: $state.$current,
                notify: false // This makes it not reload
            }).then(function () {
                window.scrollTo(0, scrollY);
            });
        }

        function getUpcomingConcerts() {
            if (cache.exists('upcoming_concerts')) {
                vm.upcoming_concerts = cache.load('upcoming_concerts');
                return Promise.resolve();
            } else {
                return $http.get('api/users/private/upcoming_concerts')
                    .then(function (response) {
                        vm.upcoming_concerts = response.data.upcoming_concerts;
                        vm.promotion_targets = response.data.promotion_targets;
                        cache.save('upcoming_concerts', vm.upcoming_concerts);
                    });
            }
        }

        function getPastConcerts() {
            return $http.get('api/users/private/past_concerts')
                .then(function (response) {
                    vm.past_concerts = response.data;
                });
        }

        function getUpcomingBookings() {
            if (cache.exists('upcoming_bookings')) {
                vm.upcoming_bookings = cache.load('upcoming_bookings');
                return Promise.resolve();
            } else {
                return $http.get('api/upcoming_bookings')
                    .then(function (response) {
                        vm.upcoming_bookings = response.data;
                        cache.save('upcoming_bookings', vm.upcoming_bookings);
                    });
            }
        }

        function getPastBookings() {
            return $http.get('api/past_bookings')
                .then(function (response) {
                    vm.past_bookings = response.data;
                });
        }

        function getUserAffilliates() {
            return $http.get('api/users/user_affiliates/')
                .then(function (response) {
                    vm.user_bands = response.data.affiliates.band ? response.data.affiliates.band : [];
                    vm.user_hosts = response.data.affiliates.space ? response.data.affiliates.space : [];
                });
        }

        function sortConcertsAndBookings(concerts, bookings, mode){
            var concerts_and_bookings = []

            concerts.forEach(concert => {
                concert.time = concert.concert_start_time;
                concert.is_past = mode === 'past';
                concerts_and_bookings.push(concert)
            });

            bookings.forEach(booking => {
                booking.time = booking.band_booking_date ? moment(booking.band_booking_date.substr(0,10) + ' ' + booking.band_booking_time).toDate() : new Date();
                booking.is_past = mode === 'past';
                concerts_and_bookings.push(booking)
            });

            if (mode == "past"){
                return concerts_and_bookings.sort((a,b)=>new Date(b.time) - new Date(a.time));
            }

            return concerts_and_bookings.sort((a,b)=>new Date(b.time) + new Date(a.time));
        }
    }
})();
